module.exports = __webpack_public_path__ + "c9c5ca32040db4641e5cb153b5aa83.svg";